import type { CustomAxiosRequestConfig } from 'types/commons/model'
import type { OtpResponse } from 'types/utils/model'
import { oneStopCheckinAxiosInstance } from './one-stop-checking.axios.instance'

export const generateOTP = async (otpType: string): Promise<OtpResponse> => {
  const axios = oneStopCheckinAxiosInstance()
  return await axios.post('/api/otps', { otpType }).then((e) => e.data)
}

export const validateOTP = async (otpCode: string, otpTye): Promise<void> => {
  const axios = oneStopCheckinAxiosInstance()
  const options: CustomAxiosRequestConfig = { skipErrorAlert: true }
  return await axios
    .delete(`/api/otps/${otpCode}?otpType=${otpTye}`, options)
    .then((e) => e.data)
}
